import { DashboardWrapper } from "@/components/dashboard/DashboardWrapper";

export default function Dashboard() {
  return <DashboardWrapper />;
}
